import { useUserStore } from '../../../store/models';

// Access is granted only to internal/test email domains — none belong to real clients or customers.
const ENV_ALLOWED_EMAIL_SUFFIXES = {
    stage: ['@e-diary.com', 'mailosaur.net', 'instantbox.live'],
    prod:  ['@e-diary.com', '@r3ygukil.mailosaur.net'],
};

function isEmailAllowed (email, env) {
    const allowedSuffixes = ENV_ALLOWED_EMAIL_SUFFIXES[env];

    // Test env: allow all emails
    if (!allowedSuffixes) {
        return true;
    }

    return allowedSuffixes.some((suffix) => email.endsWith(suffix));
}

function useConnectIntegrationByDev () {
    const userStore = useUserStore();
    // Read the observed token so MobX resubscribes when a superadmin switches publisher.
    void userStore.observed.publisher;
    const publisherEmail = userStore.publisher?.email || '';
    const env = import.meta.env.VITE_ENV_VAR || 'dev';

    const devAccess = isEmailAllowed(publisherEmail, env);

    return {
        devAccess,
    };
}

export default useConnectIntegrationByDev;
